const localHostAliases = new Set(['localhost', '127.0.0.1'])

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

export function resolveBrowserLocalApiUrl(configuredUrl: string, currentOrigin?: string) {
  const normalizedUrl = trimTrailingSlash(configuredUrl)
  const browserOrigin = currentOrigin ?? (typeof window !== 'undefined' ? window.location.origin : undefined)
  if (!browserOrigin) {
    return normalizedUrl
  }

  try {
    const apiUrl = new URL(normalizedUrl)
    const pageUrl = new URL(browserOrigin)

    if (!localHostAliases.has(apiUrl.hostname) || !localHostAliases.has(pageUrl.hostname)) {
      return normalizedUrl
    }

    if (apiUrl.hostname === pageUrl.hostname) {
      return normalizedUrl
    }

    apiUrl.hostname = pageUrl.hostname
    return trimTrailingSlash(apiUrl.toString())
  }
  catch {
    return normalizedUrl
  }
}
